import {
    facebookLinkRegExp,
    instagramLinkRegExp,
    vkLinkRegExp,
    youtubeLinkRegExp,
    youtuLinkRegExp,
} from '../regexps';
import type { Validator } from './types';

const urlRegexps = [
    instagramLinkRegExp,
    vkLinkRegExp,
    facebookLinkRegExp,
    youtubeLinkRegExp,
    youtuLinkRegExp,
];

export function makePostLinkValidator(): Validator<string> {
    return (value?: string) =>
        !value || urlRegexps.some((re) => re.test(value))
            ? 'Из поста вы можете вести на ваш сайт или маркетплейс'
            : undefined;
}
